import React from "react";
import { styled } from "styled-components";
import SyncLoader from "react-spinners/SyncLoader";

const Loading = styled("span")`
  font-size: 30px;
  color: #00ff40;
  user-select: none;
  text-align: center;
  align-items: center;
  margin: 80px;
  font-weight: bold;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
`;

const LoadingScreen = () => {
  return (
    <Loading
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        alignContent: "center",
        marginTop: "25%",
      }}
    >
      <SyncLoader
        color="#001529"
        size={30}
        margin={20}
        aria-label="Loading Hash Reticule"
        data-testid="loader"
      />
    </Loading>
  );
};
export default LoadingScreen;
